import { getDashColor } from './index'
import styled from 'styled-components'
import useBdApp from '../hooks/bdapp/useBdApp'
import React from 'react'

const StyledContainer = styled.div<{ $isNative?: boolean }>`
  width: 100%;
  margin: 0 auto;
  display: flex;
  padding-top: ${(props) => (props.$isNative ? '10px' : '94px')};
  @media (max-width: 1000px) {
    padding-top: ${(props) => (props.$isNative ? '10px' : '63px')};
    padding-bottom: 120px;
  }
`

export const Container: React.FC<React.PropsWithChildren> = ({ children }) => {
  const { isNative } = useBdApp()
  return <StyledContainer $isNative={isNative}>{children}</StyledContainer>
}

export const MenuContainer = styled.div`
  width: 100%;
  max-width: 290px;
  padding: 0 20px;
  border-right: 1px ${getDashColor('GRAY_SCALE_08', 'BEIGE')} solid;
  @media (max-width: 1000px) {
    display: none;
  }
`
